import { Injectable, EventEmitter, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { of, Subject } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import * as queue from 'queue';
import { environment } from 'environments/environment';
import { PromotionsService } from 'app/services/promotions.service';
import { CurrentUser } from 'app/services/currentUser.service';
import * as fromApp from '../../../app.reducer';
import * as fromNew from '../../../+stories/new/store/new.reducer';
import * as newActions from '../../../+stories/new/store/new.actions';
import { FirebaseService } from 'app/services/firebase.service';
import { ProjectService } from 'app/services/project.service';
import { LoggingService, LogAppSection } from 'app/services/logging.service';
declare const Buffer;
@Injectable()
export class UploadService {
  projectId: null | string;
  projectTitle: null | string;
  storyId;
  eventEmitter: EventEmitter<any> = new EventEmitter();
  onUploadReset: EventEmitter<any> = new EventEmitter();
  images = [];
  uploadStatus: fromNew.UploadStatus;
  isUploadCompletedMessageDisplaying = false;
  lastOrderDesignMode: string;
  storyCreated = false;
  designOptions = new Subject();
  s3keys = {};
  transferingImages;
  isDesignTipsShowing = false;
  uploadCancelled;
  updateProjectErrorCount = 0;
  thumbnailsUploadBegin = false;
  imagesUploadBegin = false;
  ProgressBar = 0;
  private baseUrl = environment.API;
  private albums: Array<Object> = [];
  private q = queue({ concurrency: 1 });

  constructor(
    private http: HttpClient,
    private router: Router,
    private firebaseService: FirebaseService,
    private promotionsService: PromotionsService,
    private currentUser: CurrentUser,
    private store: Store<fromApp.AppState>,
    private projectService: ProjectService,
    private loggingService: LoggingService,
  ) {
    this.store.select('new').subscribe(storyUploading => {
      this.uploadStatus = storyUploading.uploadStatus;
    });

  }

  setProjectId(pProjectId: string) {
    this.projectId = pProjectId;

  }
  selectedImages() {
    return this.images.filter(image => !image.unchecked);
  }

  getAlbums() {
    return this.albums;
  }

  unsetAlbums() {
    this.albums = [];
    this.eventEmitter.emit(this.albums);
  }

  hasAlbums() {
    return !!this.albums.length;
  }

  filterChosenImages() {
    this.images = this.images.filter(image => !image.unchecked);
  }

  startUpload() {
    this.uploadStatus.thmbStatus = 'uploading';
    this.store.dispatch(new newActions.StartUpload());
    this.loggingService.log('Upload started', {
      appSection: LogAppSection.StoryCreating,
    });
    return this.addImagesToProject(this.projectId)
      .pipe(
        concatMap(data => {
          window.scrollTo(0, 0);
          this.transferingImages = data['results'];
          return this.setupImageUpload(this.transferingImages);
        }),
        concatMap(data => {
          this.s3keys['thumbs'] = data;
          return this.setupImageUpload(this.transferingImages, true);
        })
      )
      .subscribe(data => {
        this.s3keys['hires'] = data;
        this.uploadProjectImages(this.s3keys);
      });
  }



  waitForUpload() {
    if (this.uploadsInfoReady()) {
      this.startUpload();
    } else {
      setTimeout(() => {
        this.waitForUpload();
      }, 0);
    }
  }

  uploadsInfoReady() {
    return this.images.every(image => {
      return (
        image.previewGenerated &&
        image.thumbnailGenerated &&
        image.gpsGenerated &&
        image.orientationGenerated &&
        image.dateGenerated
      );
    });
  }

  public addImagesToProject(projectId) {
    const url = `${this.baseUrl}/images/project/${projectId}/`;
    this.images = this.selectedImages();
    const projectImages = this.images.map(image => {
      const settings = {
        source: 's3',
        filename: image.name,
        handle: '',
        width: image.originalWidth,
        height: image.originalHeight,
        taken_at: image.date,
        orientation: image.orientation,
        favorite: image.frontcover,
        selected: !image.unchecked,
      };
      if (image.longitude && image.latitude) {
        settings['latitude'] = image.latitude;
        settings['longitude'] = image.longitude;
      }
      return settings;
    });
    return this.http.post(url, { images: projectImages });
  }

  private setupImageUpload(images, hires = false) {
    const url = `${this.baseUrl}/images/upload/${hires ? '?hires' : ''}`;

    const imagesIds = images.map(image => {
      return image.id;
    });
    return this.http.post(url, { images: imagesIds });
  }

  private uploadProjectImages(data) {

    this.configureS3(data.thumbs.upload);
    const s3 = new S3({
      apiVersion: '2006-03-01',
      params: { Bucket: data.thumbs.upload.bucket_name },
    });
    data.thumbs.results.forEach((item, index) => {
      this.q.push(cb => {
        this.uploadThumbnail(
          s3,
          item,
          {
            file: this.images[index].originalFile,
            thumbnail: new Buffer(this.images[index].preview.replace(/^data:image\/\w+;base64,/, ''), 'base64'),
          },
          index,
          0,
          cb
        );
      },
      );
    });
    this.q.push(cb => {
      this.configureS3(data.hires.upload, cb);
    });
    data.hires.results.forEach((item, index) => {
      this.q.push(cb => {
        this.uploadImage(s3, item, this.images[index].originalFile, index, 0, cb);
      });
    });
    this.q.start();
  }

  private configureS3(params, cb = null) {
    AWS.config.update({
      region: params.region_name,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: params.identity_pool_id,
        IdentityId: params.identity_id,
        Logins: {
          'cognito-identity.amazonaws.com': params.token,
        },
      }),
    });
    if (cb) {
      cb();
    }
  }

  private uploadThumbnail(s3, item, file, index, tryNum, cb) {
    if (this.uploadStatus.thmbStatus !== 'uploading') {
      return;
    }

    const firebaseEventName = tryNum
      ? 'thumbnails_upload_resume'
      : !this.thumbnailsUploadBegin
      ? 'thumbnails_upload_begin'
      : '';
    if (firebaseEventName) {
      this.thumbnailsUploadBegin = true;
      const params = tryNum
        ? {
            project_id: this.projectId,
            upload_target: this.images.length,
            upload_count: index + 1,
            image_id: item.id,
            filename: file.file.name,
            progress: this.uploadStatus.thumbnailPercent,
          }
        : {
            project_id: this.projectId,
            upload_target: this.images.length,
          };
      this.firebaseService.logEvent(firebaseEventName, params);
    }

    s3.upload(
      {
        Key: item.key,
        Body: file.thumbnail,
        ACL: 'private',
        ContentEncoding: 'base64',
        ContentType: 'image/jpeg',
      },
      (err, data) => {
        if (err) {
          const nextTryNum =
            err.name === 'RequestAbortedError' ? tryNum : tryNum + 1;
          this.uploadThumbnail(s3, item, file, index, nextTryNum, cb);
          this.firebaseService.logEvent('thumbnails_upload_transfer_error', {
            project_id: this.projectId,
            upload_target: this.images.length,
            upload_count: index + 1,
            image_id: item.id,
            filename: file.file.name,
            progress: this.uploadStatus.thumbnailPercent,
          });
        } else {
          if (this.uploadStatus.thmbStatus === 'uploading') {
            this.images[index].thumbUploaded = true;
            this.updateUploadStatus();
            cb();
          }
        }
      }
    );
  }

    private uploadImage(s3, item, file, index, tryNum, cb) {
    if (this.uploadStatus.status !== 'uploading') {
      return;
    }

    const firebaseEventName = tryNum
      ? 'images_upload_resume'
      : !this.imagesUploadBegin
      ? 'images_upload_begin'
      : '';
    if (firebaseEventName) {
      this.imagesUploadBegin = true;
      const params = tryNum
        ? {
            project_id: this.projectId,
            upload_target: this.images.length,
            upload_count: index + 1,
            image_id: item.id,
            filename: file.name,
            progress: this.uploadStatus.progressPercent,
          }
        : {
            project_id: this.projectId,
            upload_target: this.images.length,
          };
      this.firebaseService.logEvent(firebaseEventName, params);
    }

    s3.upload(
      {
        Key: item.key,
        Body: file,
        ACL: 'private',
        ContentEncoding: '',
        ContentType: '',
      },
      (err, data) => {
        if (err) {
          const nextTryNum =
            err.name === 'RequestAbortedError' ? tryNum : tryNum + 1;
          this.uploadImage(s3, item, file, index, nextTryNum, cb);
          this.firebaseService.logEvent('images_upload_transfer_error', {
            project_id: this.projectId,
            upload_target: this.images.length,
            upload_count: index + 1,
            image_id: item.id,
            filename: file.name,
            progress: this.uploadStatus.progressPercent,
          });
        } else {
          if (this.uploadStatus.status === 'uploading') {
            this.images[index].uploaded = true;
            this.updateUploadStatus();
            cb();
          }
        }
      }
    );
  }

  cancelUploading(redirectUrl = '/stories') {
    this.uploadCancelled = true;

    this.projectService.cancel(this.projectId).subscribe(
      () => {
        this.initUploadStatus();

        this.firebaseService.logEvent('design_request_project_cancel', {
          project_id: this.projectId,
        });

        if (this.images.find(image => !image.thumbUploaded)) {
          this.firebaseService.logEvent('thumbnails_upload_cancel', {
            project_id: this.projectId,
            upload_target: this.images.length,
            upload_count: this.images.filter(image => image.thumbUploaded)
              .length,
          });
        }

        if (this.images.find(image => !image.uploaded)) {
          this.firebaseService.logEvent('images_upload_cancel', {
            project_id: this.projectId,
            upload_target: this.images.length,
            upload_count: this.images.filter(image => image.uploaded).length,
          });
        }
      },
      err => {
        this.loggingService.error(err.message);
      }
    );

    this.router.navigate([redirectUrl]);
  }

  initUploadStatus() {
    this.store.dispatch(new newActions.InitUpload());
    this.loggingService.log('Upload inited', {
      appSection: LogAppSection.StoryCreating,
    });
    this.onUploadReset.emit();
    this.q.end();
    this.store.dispatch(new newActions.UpdateSubmitting(false));
    this.uploadCancelled = false;
  }

  private updateUploadStatus() {
    if (!this.images || !this.currentUser.get()) {
      this.initUploadStatus();
      return;
    }

    const thumbUploaded = this.images.filter(image => image.thumbUploaded);
    const thumbnailPercent = (thumbUploaded.length / this.images.length) * 100;
    const thumbnailCounter = `${thumbUploaded.length}/${this.images.length}`;
    const thmbStatus = thumbnailPercent === 0 ? 'inital' : thumbnailPercent < 100 ? 'uploading' : 'finished';
    const uploaded = this.images.filter(image => image.uploaded);
    const progressPercent = (uploaded.length / this.images.length) * 100;
    const progressCounter = `${uploaded.length}/${this.images.length}`;
    const status =
      progressPercent === 0
        ? 'waiting'
        : progressPercent < 100
        ? 'uploading'
        : 'finished';

    const uploadStatus = {
      thumbnailPercent,
      thumbnailCounter,
      thmbStatus,
      progressPercent,
      progressCounter,
      status,
    };
    this.store.dispatch(new newActions.UpdateStatus(uploadStatus));
    this.store.dispatch(new newActions.UpdateSubmitting(true));

    if (thmbStatus === 'finished' && status === 'waiting') {
      uploadStatus['status'] = 'uploading';
      this.store.dispatch(new newActions.UpdateStatus(uploadStatus));

      this.firebaseService.logEvent('thumbnails_upload_complete', {
        project_id: this.projectId,
        upload_count: this.images.length,
      });
    }

    if (status === 'finished' && thmbStatus === 'finished') {
      this.firebaseService.logEvent('images_upload_complete', {
        project_id: this.projectId,
        upload_count: this.images.length,
      });
      this.promotionsService.clear();
      this.storyCreated = false;
      this.initUploadStatus();
      this.uploadStatus.thmbStatus = 'inital';
    }
    this.updateProgressBar(progressPercent);
  }
  updateProgressBar(percent: number) {
    if (this.ProgressBar < 100) {
      this.ProgressBar = percent;
    }
  }
}
